import 'css-chunk:../components/index.module.scss';export default {
  "img": "_img_w7g8l_1"
};